module.exports = __webpack_public_path__ + "static/media/Zach_Poster.fc4225f5.png";